<template>
    <div class="container justify-content-center mt-4" id="contact-us">
      <div class="row justify-content-center">
        <div class="col-sm-12">
          <div class="row justify-content-center">
            <div  class="justify-content-center">
                <contact></contact>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Contact from "./components/Contact.vue";
  
  export default {
    name: "contactUs",
    components: {
      Contact,
    },
  };
  </script>
  